import React from "react";
import "./Acheivement.css";
import { FaHandshake, FaUsersCog, FaMedal } from "react-icons/fa";
import CountUp from "react-countup";

function Acheivement() {
  return (
    <div id="acheivement">
      <div className="acheivement-container">
        <div className="acheivement-box">
          <FaHandshake className="icon project" />
          <h1>
            <CountUp start={0} end={390} duration={5} delay={0} />
          </h1>
          <h4>Projects Completed</h4>
        </div>

        <div className="acheivement-box">
          <FaUsersCog className="icon clients" />
          <h1>
            <CountUp start={0} end={260} duration={5} delay={0} />
          </h1>
          <h4>Happy Clients</h4>
        </div>

        <div className="acheivement-box">
          <FaMedal className="icon success" />
          <h1>
            <CountUp start={0} end={348} duration={5} delay={0} />
          </h1>
          <h4>Successful Deliveries</h4>
        </div>
      </div>
    </div>
  );
}

export default Acheivement;
